import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import Members from '../principals/members'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import principals from 'scoreboard/components/principals'
import unwrapModel from 'scoreboard/components/unwrap-model'
import RollupTreeCollapsiblePanel from './rollup-tree-collapsible-panel'
import ActionsTable from './rollup-tree-group-actions-table'
import panelHeaderGroup from './rollup-tree-panel-header.hbs'
/**
 * A DatasetsTreeCollapsiblePanel with the rollupTreeGroup label and principals
 */
const RollupTreeGroupPanel = RollupTreeCollapsiblePanel.extend({

	labelKey: 'datasets.rollupTreeGroup.name',

	/**
	 * @property {RollupTreeGroup} model
	 * @property {Number} model.id
	 * @property {String} model.label
	 * @property {Number} model.treeRootId
	 * @property {Principal[]} model.principals
	 *
	 * @param {Boolean} options.collapsed see Collapsible.js
	 */
	initialize: function(options) {
		this.options = options || {}

		const {id, label} = unwrapModel(this.model)

		this.options.header = panelHeaderGroup({
			id,
			label: label || i18n.get('common.name'),
			viewAll: !_.isNil(id),
			toggle: true})

		this.options.content = `<div data-id="${id}"
			class="rollup-tree-group-panel rollup-tree-group">
		</div>`

		RollupTreeCollapsiblePanel.prototype.initialize.apply(this, arguments)
	},

	render: function() {
		RollupTreeCollapsiblePanel.prototype.render.apply(this, arguments)
		this.options.maxHeight = () => this.panel.height()
		this.panel = this.$('.rollup-tree-group-panel')

		this.labelInput = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()

		this._renderMembers()
	},

	_updateHeaderCount(c) {
		this.$('.panel-header .count').html(c || 0)
	},

	_renderMembers: function () {
		const {members = []} = unwrapModel(this.model)

		this.members = new Members({
			icon : member => member.type == 'user' ? 'user-avatar' : 'profile',
			editable: true,
			members
		})
		this.members.on('change', mems => {
			this._updateHeaderCount(mems.length)
			this.trigger('change', mems)
		})
		this.$('.rollup-tree-group-panel').append(this.members.el)
		this.members.render()
		this._updateHeaderCount(members.length)

		// Preserve the datasetTreePrincipalIds
		const principalMap = principals.toMap(members)
		_.each(this.members.getMemberEls(), m => {
			const member = $(m)
			const p = principals.hashCode(member.data())
			member.data('datasetTreePrincipalId',
				principalMap.get(p).datasetTreePrincipalId)
		})

		// When the member list is changed, we need to change the max-height of
		// the collapsible panel so it displays all of the content.
		this.$('.member-list-panel').on('click', () => this.resize())
		this.members.on('change', () => this.resize())
	},

	readFromDom: function() {
		const id = this.panel.data('id')
		const label = this.model.get('label')
		const principals = this.members.getMembers()
		return {id, label, principals}
	},

	_onClickCopy: function() {
		const {id, label, treeRootId, members} = unwrapModel(this.model)
		const url = `api/dataset-trees/${treeRootId}/rollup-tree-groups/${id}/copy`
		this._copy(label, {isNew: true}, url, (formData, response) => {
			return {
				id,
				label: formData.label,
				treeRootId,
				members
			}
		})
	},

	/**
	 * @param {Event} e
	 */
	_onClickDelete: function(e) {
		const {id, treeRootId} = unwrapModel(this.model)
		const url = `api/dataset-trees/${treeRootId}/rollup-tree-groups/${id}/delete-dependencies`
		this._delete(e, this.model, url,
			'datasets.rollupTreeGroup.delete.confirm',
			messageKeysByDomainType)
	},

	_onClickViewAll: function(e) {
		const {treeRootId, id, label} = unwrapModel(this.model)
		ActionsTable.dialog({
			rollupTreeGroupId: id,
			rollupTreeGroupLabel: label,
			treeRootId
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.members], 'remove')
	}
})

const messageKeysByDomainType = {
	dataset: 'datasets.rollupTreeGroup.delete.confirm.dependencies',
	'organization-template-permission': 'datasets.rollupTreeGroup.delete.confirm.dependencies.organizationTemplatePermission'
}

export default RollupTreeGroupPanel

RollupTreeGroupPanel.__filename__ = 'admin/datasets/rollup-tree-group-panel.js'
